import styled from "styled-components";

import "./main-layout.css";
import Footer from "../components/footer";

const MainLayout = ({ children }: any) => {
  return (
    <div className="mainLayout">
      <Container className="container">
        <ContentWrapper>
          {children}
        </ContentWrapper>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </Container>
    </div>
  );
};

export default MainLayout;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  background-size: cover;
  display: flex; 
  flex-direction: column;
  justify-content: space-between; 
`;

const ContentWrapper = styled.div`
  flex-grow: 1; 
  padding-bottom: 2rem; 
  display: flex;
  flex-direction: column;

`;

const FooterWrapper = styled.div`
margin-top:5px;
  padding-top: 2rem; 
`;

